import { create } from "zustand";

/**
 * Open state for the global command palette (`SearchMenu`). Lives in a store
 * so any surface — navbar trigger, sidebar "Search" row, ⌘K hotkey — can open
 * the same single dialog instance mounted in the navbar.
 */
interface CommandMenuState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const useCommandMenuStore = create<CommandMenuState>()((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
}));

export function useCommandMenu() {
  const open = useCommandMenuStore((s) => s.open);
  const setOpen = useCommandMenuStore((s) => s.setOpen);
  const toggle = useCommandMenuStore((s) => s.toggle);
  return { open, setOpen, toggle };
}
